import React, { useState, useEffect } from "react";
import { UserAuth } from "../Context";
import { toast } from "react-toastify";
import { toastOptions } from "../lib/toastOptions";
import uuid4 from "uuid4";
import { db } from "../FirebaseConfig";
import { Link } from "react-router-dom";
import {
  getDoc,
  doc,
  updateDoc,
  setDoc,
  deleteDoc,
  serverTimestamp,
  getDocs,
  collection,
  increment,
  onSnapshot,
  where,
  query,
  writeBatch,
} from "firebase/firestore";
import useModalStore from "../StatesStore/ModalStore";
import usePoints from "../hooks/user/usePoints";
import usePointsStore from "../StatesStore/PointsTable";
import useFavStore from "../StatesStore/FavStore";
import useLogActivity from "../hooks/user/useLogActivity";
import useChatClient from "../StatesStore/ChatClient";
import { Modal } from "react-bootstrap";
import axios from "axios";
import { updateProductAvailableIn } from "../lib/updateProductAvailableIn";
import { Plus } from "react-bootstrap-icons";
import { saveShoppingListToAlgolia } from "../lib/algoliaFunctions";
import { usePointsSystem } from "../Points/usePointsSystem";
import BottomTray from "../Trays/BottomTray";
import SaveToList from "../Trays/SaveToList";
import { usePostHog } from "posthog-js/react";

function AddToList({ product, componentName, setFavouritesCount }) {
  const { user } = UserAuth();
  const [savedLists, setSavedLists] = useState([]);
  const [shoppingList, setShoppingList] = useState({});
  const [newListName, setNewListName] = useState("");
  const [invitedLists, setInvitedLists] = useState([]);
  const [lists, setLists] = useState([]);
  const { addPoints, removePoints } = usePoints();
  const [error, setError] = useState(false);
  const pointsTable = usePointsStore((state) => state.pointsTable);
  const setFavorites = useFavStore((state) => state.setFavorites);
  const deleteFavorite = useFavStore((state) => state.deleteFavorite);
  const { logActivity } = useLogActivity(user?.uid);
  const [invitedListsStatus, setInvitedListsStatus] = useState({});
  const client = useChatClient((state) => state.client);
  const posthog = usePostHog();

  const [showPrimaryModal, setShowPrimaryModal] = useState(false);
  const [showSecondaryModal, setShowSecondaryModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const { awardPoints } = usePointsSystem(user?.uid);
  const [isOpen, setIsOpen] = useState(false);
  const handleCloseSecondaryModal = () => setShowSecondaryModal(false);
  const handleClosePrimaryModal = () => setShowPrimaryModal(false); // console.log("product", product);
  // console.log("shoppingList", shoppingList);
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 768);
  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  useEffect(() => {
    if (!shoppingList) return;
    // console.log("shoppingList", shoppingList);
  }, [shoppingList]);
  useEffect(() => {
    if (!invitedLists) return;
    // console.log("invitedLists", invitedLists);
  }, [invitedLists]);

  const fetchData = async () => {
    if (!user) return;

    const shoppingListRef = collection(db, "users", user?.uid, "shoppingList");

    const unsubscribe = onSnapshot(
      shoppingListRef,
      async (shoppingListSnapshot) => {
        const newListNames = shoppingListSnapshot.docs.map((doc) => ({
          id: doc?.id,
          listName: doc.data().listName,
          listId: doc.data().listId,
        }));
        setSavedLists(newListNames);

        const updatedShoppingList = {};

        const listPromises = shoppingListSnapshot.docs.map(async (docSnap) => {
          const listName = docSnap?.id;
          const productsRef = collection(
            db,
            "users",
            user?.uid,
            "shoppingList",
            listName,
            "products"
          );
          const productsSnapshot = await getDocs(productsRef);
          const productIds = productsSnapshot.docs.map(
            (productDoc) => productDoc?.id
          );

          updatedShoppingList[listName] = productIds;
          updatedShoppingList[
            listName
          ].dateCreated = docSnap.data().dateCreated;
          updatedShoppingList[
            listName
          ].lastUpdated = docSnap.data().lastUpdated;
        });

        await Promise.all(listPromises);

        setShoppingList(updatedShoppingList);
      }
    );
    const favoritesProductsRef = collection(
      db,
      "users",
      user?.uid,
      "shoppingList",
      "Favorites",
      "products"
    );

    const unsubscribeFavorites = onSnapshot(
      favoritesProductsRef,
      (productsSnapshot) => {
        const favoritesProducts = productsSnapshot.docs.map(
          (productDoc) => productDoc?.id
        );
        setShoppingList((prevShoppingList) => ({
          ...prevShoppingList,
          Favorites: favoritesProducts,
        }));
        if (favoritesProducts.length > 0) {
          // console.log("Favorites products updated:", favoritesProducts);
          // Update your state with the new products
          // setFavoritesProducts(favoritesProducts);
        } else {
          console.log("No products found in Favorites.");
        }
      }
    );
    // return unsubscribe;
    return () => {
      unsubscribe();
      unsubscribeFavorites();
    };
  };
  // console.log("shopping list from add to list", shoppingList);
  const fetchInvitedLists = async () => {
    if (!user) return;

    const invitedListRef = collection(db, "users", user?.uid, "invitedList");
    // const invitedQuery = query(invitedListRef, where("role", "==", "editor"));
    const invitedQuery = query(invitedListRef);
    const invitedSnapshot = await getDocs(invitedQuery);

    const invitedPromises = invitedSnapshot.docs.map(async (docSnap) => {
      const { userId } = docSnap.data();

      // Fetch inviter details
      const inviterDoc = await getDoc(doc(db, "users", userId));
      const inviterName = inviterDoc.exists()
        ? inviterDoc.data().userName
        : "Unknown";

      // Fetch the matching shopping list document
      const shoppingListRef = collection(db, "users", userId, "shoppingList");
      const shoppingListQuery = query(
        shoppingListRef,
        where("listId", "==", docSnap?.id)
      );
      const shoppingListSnapshot = await getDocs(shoppingListQuery);

      let listName = "Unknown List";
      let id = "";

      if (!shoppingListSnapshot.empty) {
        const shoppingListDoc = shoppingListSnapshot.docs[0];
        listName = shoppingListDoc?.data().listName; // Use the document ID as listName
        id = shoppingListDoc?.id; // Use the document ID as listName
      }

      return {
        id: id,
        listId: docSnap?.id,
        inviterName,
        listName,
        userId,
      };
    });

    const resolvedInvitedLists = (await Promise.all(invitedPromises)).filter(
      (list) => list !== null
    );
    setInvitedLists(resolvedInvitedLists);
  };

  const { openModal } = useModalStore();
  const [selectedSize, setSelectedSize] = useState("");

  const handleClick = () => {
    if (!user) {
      openModal("SignInModal", "", "");
    } else if (!user?.emailVerified) {
      openModal("VerifyEmailModal", "", {
        userName: user?.displayName,
        email: user?.email,
      });
    } else setShowPrimaryModal(true);
  };

  const isProductInList = (listName) => {
    const list = shoppingList[listName];
    if (list) {
      return list.includes(product?.id);
    }
    return false;
  };

  const isProductInAnyList = () => {
    return Object.values(shoppingList).some((list) =>
      list.includes(product?.id)
    );
  };

  const isProductInAnyInvitedList = () => {
    return Object.values(invitedListsStatus).some(
      (listStatus) => listStatus === true
    );
  };
  const isProductInInvitedList = async (invitedList) => {
    if (!user || !invitedList || !product?.id) return false; // Ensure necessary data exists
    // console.log('isProductInInvitedList invitedList',invitedList);

    try {
      // Reference to the product document in the invited user's shopping list
      const productDocRef = doc(
        db,
        "users",
        invitedList.userId,
        "shoppingList",
        invitedList.id,
        "products",
        product?.id
      );

      const productDoc = await getDoc(productDocRef);
      return productDoc.exists();
    } catch (error) {
      console.error("Error checking product in invited list:", error);
      return false;
    }
  };

  const textClass =
    componentName === "strip2"
      ? "text-secondary"
      : componentName === "productDetails" ||
        componentName === "BrandPage" ||
        componentName === "chat"
      ? "text-light"
      : "text-body";

  const handleListClick = async (listName, size = "", listId) => {
    if (!user) return;

    const userRef = doc(db, "users", user?.uid);

    try {
      const listDocRef = doc(db, "users", user?.uid, "shoppingList", listName);
      const productDocRef = doc(listDocRef, "products", product?.id);
      const productDoc = await getDoc(productDocRef);
      const productRef = doc(db, "products", product?.id);

      // Update the local state
      setShoppingList((prevState) => {
        const list = prevState[listName] || [];
        let updatedList;
        if (productDoc.exists()) {
          // Remove product ID
          updatedList = list.filter((id) => id !== product?.id);
        } else {
          // Add product ID
          updatedList = [...list, product?.id];
        }
        return {
          ...prevState,
          [listName]: updatedList,
        };
      });

      if (productDoc.exists()) {
        // If the product is in the list, remove it
        await deleteDoc(productDocRef);
        toast.success(`${product.name} removed from ${listName}`, toastOptions);
        // Remove the list name from the inShoppingList array
        updateProductAvailableIn(
          productRef,
          user.uid,
          "remove",
          "shoppingList",
          listId
        );

        // Decrement the shoppingListCount
        await updateDoc(userRef, {
          shoppingListCount: increment(-1),
        });

        if (listName === "Favorites") {
          setFavouritesCount((prevCount) => Math.max(prevCount - 1, 0));
          deleteFavorite(product?.id);
        }

        // Remove the product's supplier from the list's brands array
        const listDoc = await getDoc(listDocRef);
        if (listDoc.exists()) {
          const {
            category: productCategory,
            subCategory: productSubCategory,
            subSubCategory: productSubSubCategory,
          } = product;
          const {
            category = [],
            subCategory = [],
            subSubCategory = [],
            tags: listTags = [],
          } = listDoc.data();

          // Helper function to remove the first occurrence of a value from an array
          const removeFirstOccurrence = (arr, value) => {
            const index = arr.indexOf(value); // Find the index of the first occurrence
            if (index !== -1) {
              arr.splice(index, 1); // Remove the first occurrence
            }
            return arr; // Return the updated array
          };

          // Remove only the first occurrence of each value
          const updatedCategories = removeFirstOccurrence(
            [...category],
            productCategory
          );
          const updatedSubCategories = removeFirstOccurrence(
            [...subCategory],
            productSubCategory
          );
          const updatedSubSubCategories = removeFirstOccurrence(
            [...subSubCategory],
            productSubSubCategory
          );

          // Update the document with the modified arrays
          await updateDoc(listDocRef, {
            category: updatedCategories,
            subCategory: updatedSubCategories,
            subSubCategory: updatedSubSubCategories,
          });

          // Remove the first occurrence of listTags from the product's tags
          const productDoc = await getDoc(productRef);
          if (productDoc.exists()) {
            const { tags: productTags = [] } = productDoc.data();
            const updatedProductTags = removeFirstOccurrence(
              [...productTags],
              ...listTags
            );

            await updateDoc(productRef, {
              tags: updatedProductTags,
            });
          }
        }

        const activityData = {
          productId: product?.id,
          ...product,
          type: "productRemovedFromList",
        };

        logActivity(activityData);
      } else {
        // If the product is not in the list, add it
        await setDoc(productDocRef, {
          size: size,
          timestamp: serverTimestamp(),
          likeCount: 0,
          updatedAt: serverTimestamp(),
        });

        // Add the user to the product's shoppingList subcollection
        // await setDoc(productShoppingListDocRef, {
        //   timestamp: serverTimestamp(),
        // });
        toast.success(`${product.name} added to ${listName}`, toastOptions);
        // Increment the shoppingListCount
        await updateDoc(userRef, {
          shoppingListCount: increment(1),
        });

        // Update or create the inShoppingList entry
        await updateProductAvailableIn(
          productRef,
          user.uid,
          "add",
          "shoppingList",
          listId
        );
        // Add the product's supplier to the list's brands array (allow duplicates)
        const listDoc = await getDoc(listDocRef);
        if (listDoc.exists()) {
          const {
            brands = [],
            category = [],
            subCategory = [],
            subSubCategory = [],
            tags: listTags = [],
          } = listDoc.data();
          // Append the supplier to the array (duplicates allowed)
          await updateDoc(listDocRef, {
            brands: [...brands, product.supplier],
          });

          await updateDoc(listDocRef, {
            brands: [...brands, product.supplier],
            category: [...category, product?.category || null],
            subCategory: [...subCategory, product?.subCategory || null],
            subSubCategory: [
              ...subSubCategory,
              product?.subSubCategory || null,
            ],
          });

          // Add the listTags to the product's tags
          const productDoc = await getDoc(productRef);
          if (productDoc.exists()) {
            const { tags: productTags = [] } = productDoc.data();
            await updateDoc(productRef, {
              tags: [...productTags, ...listTags], // Add listTags to productTags
            });
          }
        } else {
          // If the list document doesn't exist, create it with the supplier
          await setDoc(listDocRef, {
            brands: [product.supplier],
            lastUpdated: serverTimestamp(),
          });
        }
        if (listName === "Favorites") {
          // Add to favorites store
          setFavorites(product?.id);
          setFavouritesCount((prevCount) => prevCount + 1);
        }

        const activityData = {
          productId: product?.id,
          ...product,
          type: "productAddedToList",
        };

        logActivity(activityData);
      }
      await updateDoc(listDocRef, { lastUpdated: serverTimestamp() });
    } catch (error) {
      console.error("Error handling list click:", error.message);
    }
  };

  useEffect(() => {
    if (!user) return;
    fetchData();
    fetchInvitedLists();
  }, [user]);
  useEffect(() => {
    const updateInvitedListsStatus = async () => {
      const statusMap = {};
      for (const list of invitedLists) {
        statusMap[list?.id] = await isProductInInvitedList(list);
      }
      setInvitedListsStatus(statusMap);
    };

    if (invitedLists.length > 0) {
      updateInvitedListsStatus();
    }
  }, [invitedLists, product?.id]);
  const handleCreateNewList = async (size = "") => {
    setLoading(true);
    if (newListName?.length === 0 || error || newListName[0] === " ") return;
    else if (/^\d+$/.test(newListName)) {
      setError("List name cannot be completely numeric");
      return;
    } else if (/[!@#$%^&*,.?":{}|<>\=+\;/\\[\]]/.test(newListName)) {
      setError("List name cannot contain special characters");
      return;
    }
    const listName = newListName.trim();

    if (listName) {
      // Capitalize the first letter
      const capitalizedListName =
        listName.charAt(0).toUpperCase() + listName.slice(1);

      const [listId, isNewList] = await addToSavedList(
        capitalizedListName,
        size
      );
      setLoading(false);
      setIsSubmitted(true);
      setSavedLists([
        ...savedLists,
        { id: listId, listName: capitalizedListName },
      ]);

      setShoppingList((prevState) => {
        const list = prevState[listId] || [];
        let updatedList;
        updatedList = [...list, product?.id];
        return {
          ...prevState,
          [listId]: updatedList,
        };
      });
      handleClosePrimaryModal();
      handleCloseSecondaryModal();
      toast.success(
        `${product.name} added to ${capitalizedListName} `,
        toastOptions
      );
      setNewListName(""); // Clear input after saving
      if (listId && isNewList) {
        awardPoints("creatingShoppingList");
        // Create a team channel for the newly created list
        await createTeamChannel(listId, capitalizedListName, user?.uid);

        await saveShoppingListToAlgolia(user, capitalizedListName);

        posthog.capture("newShoppingListCreated", {
          product: `${product?.id}`,
        });
      }

      // Increment the shoppingListCount
      await updateDoc(doc(db, "users", user?.uid), {
        shoppingListCount: increment(1),
      });
      const response = await axios.post(
        `${process.env.REACT_APP_GEMINI}/getTags`,
        {
          text: capitalizedListName,
        }
      );

      const tags = response.data.result || [];
      const listDocRef = doc(
        db,
        "users",
        user?.uid,
        "shoppingList",
        capitalizedListName
      );
      await updateDoc(listDocRef, {
        tags: tags,
      });
      // Add the listTags to the product's tags
      const productRef = doc(db, "products", product?.id);
      const productDoc = await getDoc(productRef);
      if (productDoc.exists()) {
        await updateDoc(productRef, {
          tags: tags, // Add listTags to productTags
        });
      }

      // Update or create the inShoppingList entry
      await updateProductAvailableIn(
        productRef,
        user.uid,
        "add",
        "shoppingList",
        listId
      );
      //adding points
      // const postingPoints = pointsTable.creatingShoppingList || 0;

      // addPoints({
      //   userId: user?.uid,
      //   type: "creatingShoppingList",
      //   pointsAwarded: postingPoints,
      //   fields: {
      //     listName: listName,
      //   },
      // });

      const activityData = {
        productId: product?.id,
        ...product,
        type: "productAddedToList",
      };

      logActivity(activityData);
    }
  };

  const handleInvitedListClick = async (invitedList) => {
    if (!user) return;

    const { id, listName, userId } = invitedList;

    try {
      const inviterShoppingListRef = doc(
        db,
        "users",
        userId,
        "shoppingList",
        id,
        "products",
        product?.id
      );
      const inviterUserRef = doc(db, "users", userId);
      const productDoc = await getDoc(inviterShoppingListRef);
      const isInList = productDoc.exists();

      if (isInList) {
        // Remove from list
        await deleteDoc(inviterShoppingListRef);
        setInvitedListsStatus((prev) => ({
          ...prev,
          [invitedList?.id]: false,
        }));
        toast.success(`${product.name} removed from ${listName}`, toastOptions);
        await updateDoc(inviterUserRef, {
          shoppingListCount: increment(-1),
        });
      } else {
        setInvitedListsStatus((prev) => ({
          ...prev,
          [invitedList?.id]: true,
        }));
        // Add to list
        await setDoc(inviterShoppingListRef, {
          size: selectedSize,
          timestamp: serverTimestamp(),
          likeCount: 0,
          updatedAt: serverTimestamp(),
        });

        toast.success(
          `${product.name} added to ${listName} by ${invitedList.inviterName}`,
          toastOptions
        );

        await updateDoc(inviterUserRef, {
          shoppingListCount: increment(1),
        });
      }
    } catch (error) {
      console.error("Error handling invited list:", error.message);
      toast.error("Error updating list", toastOptions);
    }
  };
  const addToSavedList = async (listName, size) => {
    if (!user) return null;

    try {
      const listDocRef = doc(db, "users", user.uid, "shoppingList", listName);
      const listDoc = await getDoc(listDocRef);

      const batch = writeBatch(db);

      const listId = listDoc.exists() ? listDoc.data().listId : uuid4();
      const isNewList = !listDoc.exists();

      if (isNewList) {
        // Add list creation to batch
        batch.set(listDocRef, {
          dateCreated: serverTimestamp(),
          lastUpdated: serverTimestamp(),
          listName,
          listId,
          visibility: "Public",
        });
      }

      const productDocRef = doc(listDocRef, "products", product?.id);
      batch.set(productDocRef, {
        size,
        timestamp: serverTimestamp(),
        likeCount: 0,
      });

      await batch.commit();

      console.log("Product added to the list successfully!");
      return [listId, isNewList];
    } catch (error) {
      setIsSubmitted(false);
      console.error("Error adding product to the list:", error);
      return null;
    }
  };
  const createTeamChannel = async (listId, listName, creatorId) => {
    try {
      const channel = await client.channel("team", listId, {
        name: listName,
        image: `https://ui-avatars.com/api/?name=${listName}`,
      });

      await channel.create();
      await channel.addMembers([
        { user_id: creatorId, channel_role: "list_admin" },
      ]);
      console.log("Team channel created successfully:", channel.id);
      return channel;
    } catch (error) {
      console.error("Error creating team channel:", error);
      throw error;
    }
  };
  return (
    <>
      {componentName === "chat" ? (
        <li className={`nav-item p-0 list-unstyled`}>
          <div
            className={`nav-link btn d-flex gap-1 align-items-center ${textClass} bg-default`}
            onClick={() => setShowPrimaryModal(true)}
          >
            <i
              className="bi bi-bookmark p-0 m-0"
              style={{ fontSize: "0.7rem" }}
            ></i>
            Save
          </div>
        </li>
      ) : componentName === "SimilarProducts" ? (
        <div className="w-100">
          <div
            className="d-flex align-items-center justify-content-center w-100"
            style={{
              borderRadius: "0px 0px 3px 0px",
              height: "40px",
              cursor: "pointer",
              backgroundColor: "#F4F9FF",
            }}
            onClick={() => handleClick()}
          >
            <div
              style={{
                fontFamily: "Inter",
                fontWeight: "400",
                fontSize: isSmallScreen ? "14px" : "16px",
                lineHeight: "100%",
                letterSpacing: "0%",
                textAlign: "center",
                color: "#005FDA",
              }}
            >
              Save to List
            </div>
          </div>
        </div>
      ) : componentName === "BrandPage" ? (
        <li className={`nav-item p-0 list-unstyled`}>
          <Link
            style={{ paddingTop: "0.1rem" }}
            className={`nav-link d-flex gap-1 align-items-center ${textClass} bg-default`}
            onClick={() => handleClick()}
          >
            <i
              className={`bi bi-bookmark${
                isProductInAnyList() || isProductInAnyInvitedList()
                  ? "-fill"
                  : ""
              } text-secondary p-0 m-0`}
            ></i>
            Save
          </Link>
        </li>
      ) : componentName === "productCard" ? (
        <div
          className="d-flex align-items-center justify-content-center w-100"
          style={{
            borderRadius: "0px 0px 3px 0px",
            height: "31px",
            cursor: "pointer",
            backgroundColor: "#F4F9FF",
          }}
          onClick={() => {
            if (isSmallScreen) {
              setIsOpen(true);
            } else {
              handleClick();
            }
          }}
        >
          <div
            style={{
              fontFamily: "Inter",
              fontWeight: "400",
              fontSize: isSmallScreen ? "11px" : "14px",
              lineHeight: "100%",
              letterSpacing: "0%",
              textAlign: "center",
              color: "#005FDA",
            }}
          >
            Save to List
          </div>
        </div>
      ) : (
        <li className={`nav-item p-0 list-unstyled`}>
          <Link
            style={{ paddingTop: "0.1rem" }}
            className={`nav-link d-flex gap-1 align-items-center ${textClass} bg-default`}
            onClick={() => handleClick()}
          >
            <i
              className={`bi bi-bookmark${
                isProductInAnyList() || isProductInAnyInvitedList()
                  ? "-fill"
                  : ""
              } text-secondary p-0 m-0`}
              style={{
                fontSize:
                  componentName === "strip" || componentName === "strip2"
                    ? "0.8rem"
                    : "",
              }}
            ></i>
            {componentName === "strip" || componentName === "strip2"
              ? ""
              : componentName === "BrandPage"
              ? "Save"
              : "Save to List"}
          </Link>
        </li>
      )}

      <style jsx>
        {`
          .primaryModal .modal-dialog {
            max-width: 32rem;
          }
          .secondaryModal .modal-dialog {
            max-width: 35rem;
          }
          .secondaryModal .modal-content {
            box-shadow: 0 0 14px rgba(0, 0, 0, 0.5);
          }
          .modal-backdrop {
            z-index: 1060 !important;
          }
        `}
      </style>
      <BottomTray text={"Save to List"} isOpen={isOpen} setIsOpen={setIsOpen}>
        <SaveToList
          savedLists={savedLists}
          handleListClick={handleListClick}
          handleInvitedListClick={handleInvitedListClick}
          invitedLists={invitedLists}
          invitedListsStatus={invitedListsStatus}
          isProductInList={isProductInList}
          error={error}
          newListName={newListName}
          setError={setError}
          setNewListName={setNewListName}
          loading={loading}
          isSubmitted={isSubmitted}
          setIsSubmitted={setIsSubmitted}
          handleCreateNewList={handleCreateNewList}
        />
      </BottomTray>
      <Modal
        show={showPrimaryModal}
        onHide={handleClosePrimaryModal}
        centered
        className="primaryModal"
      >
        <Modal.Body style={{ padding: "1.5rem" }}>
          <div className="d-flex flex-column mb-3">
            <div className="d-flex w-100 justify-content-between">
              <div className="h4">Save to List</div>
              <button
                type="button"
                style={{
                  boxSizing: "border-box",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "27px",
                  height: "27px",
                  background: "#FFFFFF",
                  border: "1px solid #FF3B30",
                  boxShadow: "1px 1px 5px rgba(30, 30, 30, 0.14)",
                  borderRadius: "25px",
                  flex: "none",
                  order: "1",
                  flexGrow: "0",
                }}
                onClick={handleClosePrimaryModal}
              >
                <svg
                  style={{ width: "11px" }}
                  width="14"
                  height="14"
                  viewBox="0 0 14 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M13 1L1 13M1 1L13 13"
                    stroke="#FF3B30"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </button>
            </div>
            <p className="m-0">
              Select and Save your favourite item to your shopping list.
            </p>
          </div>
          <ul
            className="navbar-nav d-flex flex-column gap-2"
            style={{ maxHeight: "17rem", overflow: "auto" }}
          >
            {savedLists.map((list) => (
              <li key={list?.id}>
                <div
                  className="d-flex align-items-center justify-content-between bg-white shadow-sm px-3 py-2 rounded-3"
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    handleListClick(list?.id, selectedSize, list?.listId)
                  }
                >
                  <div className="text-truncate h6 mb-0 fw-light">
                    {list?.listName}
                  </div>
                  <input
                    type="checkbox"
                    style={{ width: "15px", height: "15px" }}
                    checked={isProductInList(list?.id)}
                  />
                </div>
              </li>
            ))}

            {/* Render Invited Lists */}
            {invitedLists.map((list) => (
              <li key={list?.id}>
                <div
                  key={list.listId}
                  className="d-flex align-items-center justify-content-between bg-white shadow-sm px-3 py-2 rounded-3"
                  style={{ cursor: "pointer" }}
                  onClick={() => handleInvitedListClick(list)}
                >
                  <div className="d-flex justify-content-between w-100 me-3">
                    {list?.listName}
                    <div className="text-truncate h6 mb-0 fw-light">
                      <i>by {list.inviterName}</i>
                    </div>
                  </div>
                  <input
                    type="checkbox"
                    style={{ width: "15px", height: "15px" }}
                    checked={invitedListsStatus[list?.id] || false}
                  />
                </div>
              </li>
            ))}

            {/* Divider */}
            {(savedLists.length > 0 || invitedLists.length > 0) && (
              <li>
                <hr className="dropdown-divider" />
              </li>
            )}
          </ul>
          <div className="pt-2 d-flex flex-column gap-3">
            {/* Create New List */}
            <div
              className="d-flex align-items-center justify-content-between bg-white shadow-sm px-3 py-2 rounded-3 border btn btn-primary-soft"
              onClick={() => setShowSecondaryModal(true)}
            >
              <div>Create New List</div>
              <div>
                <Plus className="fs-4" />
              </div>
            </div>
            {/* <div className="w-100 btn btn-primary rounded-2">
              {loading ? (
                <div className="spinner-border spinner-border-sm" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              ) : (
                <div>Save</div>
              )}
            </div> */}
          </div>
        </Modal.Body>
      </Modal>
      <Modal
        show={showSecondaryModal}
        onHide={handleCloseSecondaryModal}
        centered
        className="secondaryModal"
      >
        <Modal.Body style={{ padding: isSmallScreen ? "1rem" : "2rem" }}>
          <div className="d-flex w-100 justify-content-between">
            <div className="d-flex flex-column">
              <div className="h4">Create New List</div>
              <p>Enter a name for your new list, and save the product to it.</p>
            </div>
            <button
              type="button"
              style={{
                boxSizing: "border-box",
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                alignItems: "center",
                width: "27px",
                height: "27px",
                background: "#FFFFFF",
                border: "1px solid #FF3B30",
                boxShadow: "1px 1px 5px rgba(30, 30, 30, 0.14)",
                borderRadius: "25px",
                flex: "none",
                order: "1",
                flexGrow: "0",
              }}
              onClick={handleCloseSecondaryModal}
            >
              <svg
                style={{ width: "11px" }}
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M13 1L1 13M1 1L13 13"
                  stroke="#FF3B30"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </button>
          </div>
          <div>
            <div className="input-group d-flex flex-column gap-3 p-0 mt-2">
              <input
                type="text"
                className="form-control form-control-sm focus-ring focus-ring-secondary py-2 px-3 text-decoration-none border rounded-3 w-100 fs-6"
                placeholder="Create new list"
                value={newListName}
                onChange={(e) => {
                  setError("");
                  setNewListName(e.target.value);
                  if (/^\d+$/.test(e.target.value)) {
                    setError("List name cannot be completely numeric");
                  } else if (
                    /[!@#$%^&*,.?":{}|<>\=+[\;()/]/.test(e.target.value)
                  ) {
                    setError("List name cannot contain special characters");
                  }
                }}
              />
              <button
                type="button"
                className="btn btn-primary rounded-3"
                disabled={
                  newListName?.length === 0 || error || newListName[0] === " "
                }
                // onClick={() => {
                //   if (newListName.length > 0) handleCreateNewList(selectedSize);
                // }}
              >
                {loading ? (
                  <div
                    className="spinner-border spinner-border-sm"
                    role="status"
                  >
                    <span className="visually-hidden">Loading...</span>
                  </div>
                ) : (
                  <div
                    onClick={() => {
                      if (newListName?.length > 0)
                        handleCreateNewList(selectedSize);
                    }}
                  >
                    Save
                  </div>
                )}
              </button>
            </div>
            {error && (
              <div
                className="text-danger ms-2 mt-2"
                style={{ fontSize: "0.9rem" }}
              >
                {error}
              </div>
            )}
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default AddToList;
